export default "__VITE_ASSET__Dz_YJVeB__"